import { useAutoImpersonate } from "@/utils/hooks/use-auto-impersonate";
import React, { PropsWithChildren } from "react";

/**
 * This is designed to be a singleton, only used once in the root of the project in _app.tsx,
 * rendered by the NetworkingWrapper.
 */
export const ImpersonationWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  // eslint-disable-next-line eslint-js/no-restricted-syntax
  useAutoImpersonate();
  return children;
};
